export default "__VITE_ASSET__C3pR1R64__"